import iconThinking from "../assets/illustrations/guide/mental-clarity/icons/thinking.svg";
import iconClarity from "../assets/illustrations/guide/mental-clarity/icons/clarity.svg";
import iconStress from "../assets/illustrations/guide/mental-clarity/icons/stress.svg";
import iconEnergy from "../assets/illustrations/guide/mental-clarity/icons/energy.svg";
import iconLeader from "../assets/illustrations/guide/mental-clarity/icons/leader.svg";
import iconCommunication from "../assets/illustrations/guide/mental-clarity/icons/communication.svg";
import iconAwareness from "../assets/illustrations/guide/mental-clarity/icons/awareness.svg";
import iconGrowth from "../assets/illustrations/guide/mental-clarity/icons/growth.svg";

export const GUIDE_CARD_ICONS = {
  thinking: iconThinking,
  clarity: iconClarity,
  stress: iconStress,
  energy: iconEnergy,
  leader: iconLeader,
  communication: iconCommunication,
  awareness: iconAwareness,
  growth: iconGrowth,
};

export function getGuideCardIcon(key) {
  return GUIDE_CARD_ICONS[key] || iconClarity;
}
